module.exports = __webpack_public_path__ + "static/media/nature-6.5068ecd6.svg";